import { cn } from '@/lib/utils';
import { Link } from '@tanstack/react-router';
import ImageNotFound from '@/assets/images/404/404.svg';
import ImageNotFoundMobile from '@/assets/images/404/404-mobile.svg';
import { useResponsive } from '@/hooks/use-responsive';

export default function PageNotFound({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  const { isMobile } = useResponsive();
  return (
    <section className={cn('mt-[99px] md:mt-[72px]', className)}>
      {children || (
        <div className="container text-center flex items-center justify-center">
          <div className="">
            <div className="mx-auto flex items-center justify-center">
              <img
                className=" fallback-robot"
                src={isMobile ? ImageNotFoundMobile : ImageNotFound}
                alt="image-not-found"
                loading="lazy"
              />
            </div>
            <div className="mt-4 md:mt-10">
              <h2 className="uppercase  text-2xl md:text-4xl text-black font-lateral1000">
                Oops! Page Not found
              </h2>

              <Link
                to="/"
                className="text-sm md:text-base lg:text-lg mt-2 md:mt-4"
              >
                Go back to homepage
              </Link>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
